import { trpc } from "@api/client";
import dispatchToast from "@utils/dispatch-toast";

export const useCreateDepartment = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  const { isPending: isLoading, mutateAsync: createDepartment } =
    trpc.createDepartment.useMutation({
      onError: (error) => {
        const errorCode = error.data?.code;
        if (errorCode === "CONFLICT") {
          dispatchToast({
            content:
              "Departamento com mesmo nome já existe. Por favor atribua outro nome.",
            type: "error",
          });
        } else {
          dispatchToast({
            content: "Erro ao criar departamento.",
            type: "error",
          });
        }
      },
      onSuccess,
    });

  return { isLoading, createDepartment };
};
